import { titleCase } from '~app/shared/functions/utils/utils.function';
import { environment } from '~env';
import { REPORT_NAMES } from '../constants/reports.constant';
import { ROLE_DATA } from '../constants/roleData';
import { Brand } from '../enums/brand.enum';
import { Feature } from '../enums/feature.enum';
import { Role } from '../enums/role.enum';

export class Ship {
  private readonly data: {
    code: string;
    name: string;
    activeStatus: string;
    shipClass: string;
    brand: string;
  };

  constructor(data: any) {
    this.data = data;
  }

  public get code(): string {
    return this.data.code;
  }

  public get name(): string {
    return titleCase(this.data.name);
  }

  public get brand(): Brand {
    const shipName = this.data.name.toLowerCase();
    if (shipName.includes('celebrity')) return Brand.CELEBRITY;
    if (shipName.includes('azamara')) return Brand.AZAMARA;
    return Brand.RCCL;
  }

  public get roleList(): Array<Role> {
    return environment.auth.managerGroup
      .filter(role => ROLE_DATA[role][this.brand].isEnabled)
      .filter(role => {
        if (role === Role.Safety) return this.safetyEnabled;
        return true;
      });
  }

  public get eSignatureEnabled(): boolean {
    return this.isFeatureFlagEnabledForShip(Feature.eSignature, this.code);
  }

  public get checkInEnabled(): boolean {
    return this.isFeatureFlagEnabledForShip(Feature.CheckIn, this.code);
  }

  public get checkOutEnabled(): boolean {
    return this.isFeatureFlagEnabledForShip(Feature.CheckOut, this.code);
  }

  public get medicalEnabled(): boolean {
    return this.isFeatureFlagEnabledForShip(Feature.Medical, this.code);
  }

  public get safetyEnabled(): boolean {
    return this.isFeatureFlagEnabledForShip(Feature.Safety, this.code);
  }

  public get updatePhotoEnabled(): boolean {
    return this.isFeatureFlagEnabledForShip(Feature.CrewPhotoUpdate, this.code);
  }

  public get isMedicalExpirationEnabled(): boolean {
    return this.isFeatureFlagEnabledForShip(Feature.MedicalCertificates, this.code);
  }

  public get isCovidVaxReportEnabled(): boolean {
    return this.isFeatureFlagEnabledForShip(Feature.CovidVaxReport, this.code);
  }

  public get isLastOnBoardEnabled(): boolean {
    return this.isFeatureFlagEnabledForShip(Feature.LastOnboard, this.code);
  }

  public isReportEnabled(reportId: keyof typeof REPORT_NAMES): boolean {
    switch (reportId) {
      case 'crewCheckinInfo':
        return this.isFeatureFlagEnabledForShip(Feature.CrewCheckinInfoReport, this.code);
      case 'healthCheck':
        return this.isFeatureFlagEnabledForShip(Feature.HealthCheckReport, this.code);
      case 'missingSharepointSignons':
        return this.isFeatureFlagEnabledForShip(Feature.MissingSharepointSignonsReport, this.code);
      case 'policyAcknowledgement':
        return this.isFeatureFlagEnabledForShip(Feature.PolicyAcknowledgementReport, this.code);
      case 'delayedEnvelope':
        return this.isFeatureFlagEnabledForShip(Feature.LateSignOnReport, this.code);
    }
  }

  private isFeatureFlagEnabledForShip(featureFlag: Feature, shipCode: string): boolean {
    const feature = environment.featureFlags[featureFlag];
    if (typeof feature === 'boolean') {
      return feature;
    } else {
      return feature.includes(shipCode);
    }
  }
}
